import axios from 'axios';
import variables from "./variables";
import moment from 'moment';
import { GetTenantIdUp } from './utils/Utils';
const API_ROOT = variables.apiURLs;



const GetTenantDetailsByUserName = async (UserName) => {
    // console.log(UserName);
    try {
        let response = await GetWebAPIResponse(`/api/Admin/GetTenantDetailsByUserName?UserName=${UserName}`);
        return response.data.data;
    } catch (error) {
        // console.log("GetTenantDetailsByUserName error-=-=", error);
        return undefined;
    }
}
const GetTenantList = async () => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/GetTenantList`);
        return response;
    } catch (error) {
        return undefined;
    }
}

const GetTenantPagination = async (data) => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/p/GetTenant?PageNo=${data?.PageNo}&PageSize=${data?.PageSize}`);
        return response;
    } catch (error) {
        return undefined;
    }
}


const GetUsersPagination = async (data) => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/p/GetUsers?PageNo=${data?.PageNo}&PageSize=${data?.PageSize}`);
        return response;
    } catch (error) {
        return undefined;
    }
}


const UpdateTenantUsers = async (data) => {
    try {
        let response = await postWebAPIResponse(`/api/Admin/UpdateTenantUsers`, data);
        return response.data;
    } catch (error) {
        return undefined;
    }
}
const InsertTenantUsers = async (data) => {
    try {
        let response = await postWebAPIResponse(`/api/Admin/InsertTenantUsers`, data);
        // console.log(response);
        return response;
    } catch (error) {
        // console.log("InsertTenantUsers error-=-=", error);
        return error;
    }
}
const GetUsers = async (val) => {
    try {
        const queryParams = [
            val.userName ? `UserName=${encodeURIComponent(val.userName)}` : null,
            val.firstName ? `FirstName=${encodeURIComponent(val.firstName)}` : null,
            val.lastName ? `LastName=${encodeURIComponent(val.lastName)}` : null
        ].filter(param => param !== null).join('&');
        let response = await GetWebAPIResponse(`/api/Admin/GetUsers?${queryParams}`);
        return response;
    } catch (error) {
        return error;
    }
}
// const GetUsers = async (name) => {
//     try {
//         let response = await GetWebAPIResponse(`/api/Admin/GetUsers?UserNanme=${name}&FirstName=${name}&LastName=${name}`);
//         return response;
//     } catch (error) {
//         return error;
//     }
// }
const GetTenantSecretByTenantID = async (data) => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/GetTenantSecretByTenantID?TenantId=${data.TenantId}`);
        return response.data.data;
    } catch (error) {
        return undefined;
    }
}
const GetAdminCountryList = async (data) => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/GetAdminCountryList`);
        return response.data.data;
    } catch (error) {
        return undefined;
    }
}

const GetAdminState = async (CountryId) => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/GetAdminState?CountryId=${CountryId}`);
        return response.data.data;
    } catch (error) {
        return undefined;
    }
}
const GetTenantLicenseByTenantID = async (data) => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/GetTenantLicenseByTenantID?TenantId=${data.TenantId}`);
        return response.data.data;
    } catch (error) {
        return undefined;
    }
}
const GetTenantByTenantID = async (data) => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/GetTenantByTenantID?TenantID=${+data.TenantId}`);
        return response.data.data;
    } catch (error) {
        return undefined;
    }
}
const UpdateTenant = async (data) => {
    try {
        let response = await postWebAPIResponse(`/api/Admin/UpdateTenant`, data);
        return response;
    } catch (error) {
        return undefined;
    }
}
const InsertTenant = async (data) => {
    try {
        let response = await postWebAPIResponse(`/api/Admin/InsertTenant`, data);
        return response;
    } catch (error) {
        return undefined;
    }
}
const GetTenantUserTable = async (data) => {
    try {
        // let response = await GetWebAPIResponse(`/api/Admin/GetUsers?UserName=${data.UserName}&IsActive=${data.IsActive}&TenantId=${data.TenantId}`);
        let response = await GetWebAPIResponse(`/api/Admin/GetUsers?IsActive=${data.IsActive}&TenantId=${data.TenantId}`);
        return response.data.data;
    } catch (error) {
        return undefined;
    }
}
const GetTenant = async (data) => {
    try {
        // let response = await GetWebAPIResponse(`/api/Admin/GetTenant?IsActive=${data.IsActive}&FirstName=${data.FirstName}`);
        let response = await GetWebAPIResponse(`/api/Admin/p/GetTenant?TenantId=${data.TenantId}`);
        return response.data.data;
    } catch (error) {
        return undefined;
    }
}

const GetTenantFilter = async (data) => {
    try {
        // let response = await GetWebAPIResponse(`/api/Admin/GetTenant?IsActive=${data.IsActive}&FirstName=${data.FirstName}`);
        let response = await GetWebAPIResponse(`/api/Admin/p/GetTenant?TenantId=${data?.TenantId}&PageSize=${data?.PageSize}&PageNo=${data?.pageNo}&NameSearch=${data?.NameSearch}&IsPaging=${data?.IsPaging}`);
        return response?.data;
    } catch (error) {
        return undefined;
    }
}

const deleteTenantHost = async (data) => {
    try {
        let response = await postWebAPIResponse(`/api/Admin/DeleteTenantHost`, data);
        return response?.data?.data;
    } catch (error) {
        return error;
    }
}

const InsertSingleTenantHost = async (data) => {
    try {
        let response = await postWebAPIResponse("/api/Admin/InsertSingleTenantHost", data);
        return response;
    } catch (error) {
        return error;
    }
}

const InsertTenantSingleLicense = async (data) => {
    try {
        let response = await postWebAPIResponse("/api/Admin/InsertTenantSingleLicense", data);
        return response;
    } catch (error) {
        return error;
    }
}

const UpdateSingleTenantLicense = async (data) => {
    try {
        let response = await postWebAPIResponse("/api/Admin/UpdateSingleTenantLicense", data);
        return response;
    } catch (error) {
        return error;
    }
}

const deleteSingleTenantLicense = async (data) => {
    try {
        let response = await postWebAPIResponse("/api/Admin/DeleteTenantLicense", data);
        return response;
    } catch (error) {
        return error;
    }
}

const getSmtpSettings = async (data) => {
    try {
        let response = await postWebAPIResponse2("/api/Admin/GetTenantPreferenceValues", data);
        return response;
    } catch (error) {
        return error;
    }
}

const insertSmtpSettings = async (data) => {
    try {
        let response = await postWebAPIResponse2("/api/Admin/InsertTenantPreference", data);
        return response;
    } catch (error) {
        return error;
    }
}

const DeleteTenantSecret = async (data) => {
    try {
        let response = await postWebAPIResponse2("/api/Admin/DeleteTenantSecret", data);
        return response;
    } catch (error) {
        return error;
    }
}

const InsertTenantSingleSecret = async (data) => {
    try {
        let response = await postWebAPIResponse2("/api/Admin/InsertTenantSingleSecret", data);
        return response;
    } catch (error) {
        return error;
    }
}

const UpdateSingleTenantSecret = async (data) => {
    try {
        let response = await postWebAPIResponse2("/api/Admin/UpdateSingleTenantSecret", data);
        return response;
    } catch (error) {
        return error;
    }
}

const GetStateByCountryId = async (countryId) => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/GetState?CountryId=${countryId}&TenantID=${GetTenantIdUp()}`);
        return response;
    } catch (error) {
        return error;
    }

}

const getlogos = async (data) => {
    try {
        let response = await GetWebAPIResponse(`/api/AppConfig/GetTenantPreference${data}`);
        return response;
    } catch (error) {
        return error;
    }
}

const updateEditLogos = async (data) => {
    try {
        let response = await postWebAPIResponse2(`/api/AppConfig/InsertUpdateTenantPreferences`, data);
        return response;
    } catch (error) {
        return error;
    }
}

const sendEmail = async (data) => {
    try {
        let response = await postWebAPIResponse2(`/api/Admin/SendEmailTest`, data);
        return response
    } catch (error) {
        return error
    }
}

const SetTenantInactive = async (data) => {
    try {
        let response = await postWebAPIResponse2(`/api/Admin/SetTenantInactive?TenantID=${data?.id}&UpdateBy=${data?.admin}&IsActive=false`, {});
        return response
    } catch (error) {
        return error
    }
}

// const InsertOnboardTenant = async (data) => {
//     try {
//         let response = await postWebAPIResponse(`/api/Admin/OnboardTenant`, data);
//         // console.log(response);
//         return response;
//     } catch (error) {
//         // console.log("InsertTenantUsers error-=-=", error);
//         return error;
//     }
// }


const postWebAPIResponse2 = async (ApiName, data) => {
    try {
        let get_token_data = localStorage?.getItem("tokenAdmin") ? JSON?.parse(localStorage?.getItem("tokenAdmin")) : {};
        const temp = !!get_token_data?.data.access_token;
        var expireTime = moment(new Date());
        if (!!(window.sessionStorage.getItem("expires_in"))) {
            expireTime = window.sessionStorage.getItem("expires_in");
        }
        var SatusCode = get_token_data?.statusCode;

        if (SatusCode == "200") {

            const token = get_token_data?.data?.access_token;
            const expires_in = get_token_data?.data?.expires_in;
            window.sessionStorage.setItem("WebAPIAuthToken", token);
            window.sessionStorage.setItem("expires_in", expires_in);
        }
        else {
            return get_token_data;
        }
        let response = await axios({
            method: 'post',
            url: `${API_ROOT}` + ApiName,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + get_token_data?.data?.access_token
            },
            data: data
        }
        );
        return response;
    } catch (error) {
        return error;
    }


}
const postWebAPIResponse = async (ApiName, data2) => {
    try {
        var abc = JSON.stringify(data2);
        let get_token_data = localStorage?.getItem("tokenAdmin") ? JSON?.parse(localStorage?.getItem("tokenAdmin")) : {};
        const temp = !!get_token_data?.data.access_token;


        var expireTime = moment(new Date());
        if (!!(window.sessionStorage.getItem("expires_in"))) {
            expireTime = window.sessionStorage.getItem("expires_in");
        }
        var SatusCode = get_token_data.statusCode;

        if (SatusCode == "200") {

            const token = get_token_data.data.access_token;
            const expires_in = get_token_data.data.expires_in;
            window.sessionStorage.setItem("WebAPIAuthToken", token);
            window.sessionStorage.setItem("expires_in", expires_in);
        }
        else {
            return get_token_data;
        }
        let response = await axios({
            method: 'post',
            url: `${API_ROOT}` + ApiName,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + window.sessionStorage.getItem("WebAPIAuthToken")
            },
            data: { ...data2 }
        }
        );

        return response;
    } catch (error) {
    }
}
const GetWebAPIResponse = async (ApiName) => {
    try {
        let get_token_data = localStorage?.getItem("tokenAdmin") ? JSON?.parse(localStorage?.getItem("tokenAdmin")) : {};
        var expireTime = moment(new Date());
        if (!!(get_token_data?.expires_in)) {
            expireTime = get_token_data?.expires_in;
        }
        // var curDateUtc = new Date().toUTCString();
        var SatusCode = get_token_data?.statusCode;
        if (SatusCode == "200") {
            const token = get_token_data?.data.access_token;
            const expires_in = get_token_data?.data.expires_in;
            window.sessionStorage.setItem("WebAPIAuthToken", token);
            window.sessionStorage.setItem("expires_in", expires_in);
        }
        else {
            return get_token_data;
        }
        let response = await axios({
            method: 'get',
            url: `${API_ROOT}` + ApiName,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + get_token_data?.data.access_token
            },
            data: {}
        }
        );
        // console.log("response.data-=-=", response);
        return response;
    } catch (error) {
    }
}

const GenerateAuthToken = async () => {
    try {
        let response = await axios({
            method: 'post',
            url: `${API_ROOT}/AdminAuthToken`,
            //withCredentials: true,
            data: {
                "userName": "admin",
                "password": "admi123",
            }
        }
        );
        return response.data;
    } catch (error) {
        return undefined;
    }
}
////////////////////////////////////////////////
const AuthToken = async (data) => {
    var requestdata = JSON.stringify({ UserName: data.name, Password: data.passcode, TenantId: 1 });
    let responce = [];
    var config = {
        method: 'post',
        // url: 'https://commustateapibrd.mypatientclick.com/Authtoken',
        url: `${API_ROOT}/Authtoken`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: requestdata
    };

    await axios(config)
        .then(function (response) {
            // console.log(response);
            responce = response.data;
        })
        .catch(function (error) {
        });
    return responce

}

const ClientLogin = async (data, token) => {
    //return false;
    var requestData = JSON.stringify({ UserName: data.name, Password: data.passcode, TenantId: 1 });
    let responce = [];
    var config = {
        method: 'post',
        //url: 'https://commustateapibrd.mypatientclick.com/api/UserLogin/ClientLogin',
        url: `${API_ROOT}/api/UserLogin/ClientLogin`,
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: requestData
    };

    await axios(config)
        .then((response) => {
            responce = response.data;
        })
        .catch(function (error) {
        });
    return responce;
}

const GetTenantHostById = async (data) => {
    try {
        let response = await GetWebAPIResponse(`/api/Admin/GetTenantHostByTenantID?TenantID=${data}`);
        return response?.data?.data;
    } catch (error) {
        return error;
    }
}

const GetAdminHistoryLogDetails = async (data) => {
    try {
        let response = GetWebAPIResponse(`/api/Log/GetAdminHistoryLogDetails?StartDate=${data?.startDate}&EndDate=${data?.endDate}&TenantId=${data?.id}`);
        return response;
    } catch (error) {
        return error;
    }
}

// const OnboardAuthToken = async (data) => {
//     try {
//         let response = await postWebAPIResponse("/OnboardAuthToken", data);
//         return response;
//     } catch (error) {
//         return error;
//     }
// }

const OnboardAuthToken = async (data) => {
    var data = JSON.stringify({ "apiKey": "cJON1RcbKfc0uvbJE6ETRxPkbLRcGXmr", "secretKey": "z66F6K1nFVgXBufUw9XVvvYz9DAizxwe" });

    var config = {
        method: 'post',
        url: `${API_ROOT}/OnboardAuthToken`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios(config)
        .then(function (response) {
            sessionStorage.setItem("OnboardAuthToken", response.data.data.access_token)
        })
        .catch(function (error) {
        });

}
const GetOnboardAdminCountryList = async (data) => {
    try {
        const config = {
            method: 'get',
            url: `${API_ROOT}/api/Admin/GetAdminCountryList`,
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("OnboardAuthToken")
            }
        };

        const response = await axios(config);
        return response.data.data;
    } catch (error) {
        throw error;  // Re-throw the error to be handled by the caller
    }
}

const GetOnboardAdminState = async (CountryId) => {
    try {
        const config = {
            method: 'get',
            url: `${API_ROOT}/api/Admin/GetAdminState?CountryId=${CountryId}`,
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("OnboardAuthToken")
            }
        };

        const response = await axios(config);
        return response.data.data;
    } catch (error) {
        throw error;  // Re-throw the error to be handled by the caller
    }
}

const CheckBindingUrl = async (data) => {
    try {
        var data = JSON.stringify({ "bindingDomain": data });

        const config = {
            method: 'post',
            url: `${API_ROOT}/api/Admin/CheckBindingUrl`,
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("OnboardAuthToken"),
                'Content-Type': 'application/json'
            },
            data: data
        };

        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error;  // Re-throw the error to be handled by the caller
    }

}
const InsertOnboardTenant = async (data) => {
    try {

        const config = {
            method: 'post',
            url: `${API_ROOT}/api/Admin/OnboardTenant`,
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("OnboardAuthToken"),
                'Content-Type': 'application/json'
            },
            data: data
        };

        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error;  // Re-throw the error to be handled by the caller
    }
}


export default {
    GetTenant,
    GenerateAuthToken,
    AuthToken,
    ClientLogin,
    GetTenantUserTable,
    GetTenantByTenantID,
    UpdateTenant,
    InsertTenant,
    GetTenantLicenseByTenantID,
    GetTenantSecretByTenantID,
    GetAdminCountryList,
    GetAdminState,
    InsertTenantUsers,
    UpdateTenantUsers,
    GetTenantList,
    GetTenantDetailsByUserName,
    GetUsers,
    GetTenantHostById,
    deleteTenantHost,
    InsertSingleTenantHost,
    InsertTenantSingleLicense,
    UpdateSingleTenantLicense,
    deleteSingleTenantLicense,
    getSmtpSettings,
    insertSmtpSettings,
    DeleteTenantSecret,
    InsertTenantSingleSecret,
    UpdateSingleTenantSecret,
    GetStateByCountryId,
    getlogos,
    updateEditLogos,
    sendEmail,
    SetTenantInactive,
    GetAdminHistoryLogDetails,
    InsertOnboardTenant,
    OnboardAuthToken,
    GetOnboardAdminCountryList,
    GetOnboardAdminState,
    CheckBindingUrl,
    InsertOnboardTenant,
    GetTenantFilter,
    GetUsersPagination,
    GetTenantPagination,
}
